// Feature flags for offline-sync fields that depend on backend support.
//
// GraphQL rejects input-object fields the schema doesn't declare, so the
// frontend must NOT send a field until the backend adds it. Flip a flag on
// only once the corresponding schema change from
// docs/offline-sync-backend-contract.md has shipped.
//
// Reacting to a conflict *response* (extensions.code === 'CONFLICT') is always
// safe and needs no flag. The branch simply never fires until the backend
// starts returning that code.
export const offlineSyncConfig = {
  // Inject a client-generated UUID `idempotencyKey` into queued mutations so the
  // backend can dedupe at-least-once replays (Required change 1). Requires
  // `idempotencyKey` on the mutation input types. Left ON because offline
  // support is not enabled in production until that backend change ships; turn
  // OFF to test replay against a backend that doesn't declare the field yet.
  sendIdempotencyKey: true,

  // Inject the last-seen entity version so the backend can reject a conflicting
  // concurrent edit (Required change 2). ON since migration 00069 added
  // updated_at to the infrared tables and expectedUpdatedAt to the change
  // inputs (devices already had both). Only items queued WITH a baseVersion
  // send the field, so creates/removes are unaffected.
  sendExpectedVersion: true,

  // The input field name the backend expects for the optimistic-concurrency
  // check. Keep in sync with the backend contract doc.
  expectedVersionField: 'expectedUpdatedAt',
}
